/* eslint-disable max-len */
import React from 'react';
import classNames from 'classnames';
import { CommonIconProps } from './commonIconProps';

export const IconMenu: React.FC<CommonIconProps> = ({ className }) => (
  <svg viewBox="0 0 20 40" xmlns="http://www.w3.org/2000/svg" className={classNames('icon', className)}>
    <rect y="12" width="16" height="2.5" rx="1.25" />
    <rect y="18.75" width="20" height="2.5" rx="1.25" />
    <rect y="25.5" width="12" height="2.5" rx="1.25" />
  </svg>
);
